export const EVENT_PAYMENT_UPDATE = 'payment.update'
export const EVENT_PAYMENT_CREATE = 'payment.create'
export const EVENT_PAYMENT_REVIEW_CONFIRM = 'payment.reviewConfirm'
